const roles = {
  ADMIN: 'admin',
};

export default roles;
